















import Vue, { PropType } from 'vue';
export type DataType = {
  style: any;
}
export default Vue.extend({
  name: 'GAuthTextUnderlineField',
  props: {
    value: { type: String as PropType<string>, required: true },
    label: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    name: { type: String as PropType<string>, required: true },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    error: { type: String as PropType<string>, default: '' },
    maxlength: { type: Number as PropType<number>, required: true },
  },
  computed: {
    innerValue: {
      get(): string {
        return this.value;
      },
      set(val: string): void {
        this.$emit('input', val);
      },
    },
  },
});
